export default __webpack_public_path__ + "static/html-91c24f93ff8755047a4d59ecea390b7a.png";